import(/* webpackMode: "eager" */ "/vercel/path0/src/app/courses/page.tsx");
